import React from 'react';
import styled from 'styled-components';
import RiskArtificialInflationGraphComponent from "./RiskArtificialInflationGraphComponent";
import {toDate} from "../../../util";
import {HeaderDivider} from "../HeaderDivider";
import {ReportSectionHeader} from "../SectionHeader";

import { ReportSectionSubHeader } from "../SectionSubHeader";

const GraphReportContainer = styled.div`
	@media print {
		width: 100%;
		height: 100%;
	}
`;

const convertGraphData = (stockPrices) => {
	if (!stockPrices) {
		return [];
	}

	return stockPrices.map(x => {
			return {
				t: toDate(x.date).getTime(),
				closingPriceLessInflation: x.closingPriceLessInflation,
				closingPrice: x.closingPrice,
				volume: x.volume / 1000
			}
		}
	);
};

const getMonthTicks = (stockPrices) => {

	if (!stockPrices || (stockPrices && stockPrices.length === 0)) {
		return [];
	}

	const dates = [];

	let curDate = toDate(stockPrices[0].date);
	const endDate = toDate(stockPrices[stockPrices.length - 1].date);

	let delta = 1;

	if (endDate.getFullYear() - curDate.getFullYear() >= 3) {
		//a tick every 3 months
		delta = 3;
	}

	while (curDate < endDate) {
		dates.push(curDate.getTime());
		curDate.setMonth(curDate.getMonth() + delta);
	}

	return dates;
};

const RiskArtificialInflationGraphContainer = (props) => {

	const graphData = convertGraphData(props.stockPrices);
	const tickDates = getMonthTicks(props.stockPrices);
	let isDandO = sessionStorage.getItem('DANDO');
	let graph = null;
	if (graphData.length !== 0) {
		graph = <RiskArtificialInflationGraphComponent graphData={graphData} adverseCorporateEvents={props.adverseCorporateEvents} tickDates={tickDates} isDandO={isDandO} caseRuleTypeId={props.caseRuleTypeId} />
	} else {
		graph = <div color='white'>Not enough data to display graph</div>;
	}

	return (
		<GraphReportContainer>
			<ReportSectionHeader>{isDandO === "true"?"Potential Artificial Inflation Per Share During the Evaluation Period": props.caseRuleTypeId === 3?"Closing Stock Price and Volume Through Initial Filing Date":"Stock Price Artificial Inflation During the Class Period"} </ReportSectionHeader>
			{props.aggregateDamagesNOPSLRA&&props.aggregateDamagesNOPSLRA.length!==0&&<ReportSectionSubHeader > 
		  &nbsp; &nbsp;*Damages Capped for the PSLRA 90-Day Bounce-Back Provision
		</ReportSectionSubHeader>
		}
			<HeaderDivider/>
			{graph}
		</GraphReportContainer>
	);

};


export default RiskArtificialInflationGraphContainer;


// WEBPACK FOOTER //
// ./src/common/components/RiskArtificialInflationGraph/RiskArtificialInflationGraphContainer.js